import * as React from "react";
import { forwardRef } from "react";
const SvgMinus = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("rect", { x: 3.79492, y: 9.29004, width: 12.5, height: 1.63065, rx: 0.815323, fill: "currentColor" }));
const ForwardRef = forwardRef(SvgMinus);
export default ForwardRef;
